import(/* webpackMode: "eager" */ "/app/src/app/news/[id]/page.tsx");
